import { put, select } from 'redux-saga/effects';
import { ListTags } from '../../services/tags';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'TAGS/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetTags(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const userSiteId = yield select((state) => state?.userSite?.data?._id);
    const response = yield ListTags(siteId || userSiteId)
    yield put(actions.loadSuccess(response.result));
    resolve && resolve(response.result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
